import moment from "moment";

const SLOT_MINUTES = 5;
const MINUTES_PER_DAY = 24 * 60;

const toMinutes = (hhmm) => {
  if (!hhmm) {
    return null;
  }
  const m = moment(hhmm, "HH:mm");
  return m.isValid() ? m.hours() * 60 + m.minutes() : null;
};

// End of the window in minutes since midnight of its start day. An end at or
// before the start crosses midnight; the rows only show one day, so it runs
// to the end of that day.
const resolveEnd = (start, endTime, duration) => {
  // The form's duration dropdown and PMS length override pass strings.
  const minutes = Number(duration);
  if (minutes > 0) {
    return start + minutes;
  }
  const end = toMinutes(endTime);
  if (end === null) {
    return start + SLOT_MINUTES;
  }
  return end > start ? end : MINUTES_PER_DAY;
};

/**
 * Indices of the picker rows a window covers: the rows whose time falls in
 * [start, end). A window partly outside the rows is clipped to them, and one
 * entirely outside them covers none. Always returns an array.
 */
export const getTimeslotIndices = (rows, { startTime, endTime, duration }, generateItem = (idx) => idx) => {
  const start = toMinutes(startTime);
  if (start === null) {
    return [];
  }
  const end = resolveEnd(start, endTime, duration);
  return rows.reduce((items, { value }, idx) => {
    const time = toMinutes(value);
    return time >= start && time < end ? [...items, generateItem(idx)] : items;
  }, []);
};
